export const isEmail = (email) =>
  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

export const isIBCLC = (code) => {
  if (code.length > 8) {
    return false;
  }

  return /^\d+$/.test(code);
}